
export const VISITOR_ACCESS_DESCRIPTION_PUBLIC = 'Anyone with the link can access.';
export const VISITOR_ACCESS_DESCRIPTION_PASSWORD = 'Only visitors who enter a password can access.';
export const VISITOR_ACCESS_DESCRIPTION_EMAIL = 'Only visitors with approved email addresses can access.';
export const VISITOR_ACCESS_DESCRIPTION_SSO = 'Visitors must use a Single Sign-On (SAML) Portal.';
export const VISITOR_ACCESS_DESCRIPTION_MFA = 'Visitors with approved email addresses must enter a code from a separate device.';

export const VISITOR_ACCESS_PUBLIC = 'public';
export const VISITOR_ACCESS_PASSWORD = 'password';
export const VISITOR_ACCESS_EMAIL = 'email';
export const VISITOR_ACCESS_SSO = 'SAML';
export const VISITOR_ACCESS_MFA = 'mfa';
export const VALID_VISITOR_ACCESS_SETTINGS = [
  VISITOR_ACCESS_PUBLIC,
  VISITOR_ACCESS_PASSWORD,
  VISITOR_ACCESS_EMAIL,
  VISITOR_ACCESS_SSO,
  VISITOR_ACCESS_MFA
];

export const PAGE_EMAIL_TOKEN_TYPE_EXPIRING = 'expiring';
export const PAGE_EMAIL_TOKEN_TYPE_ONE_TIME = 'ott';
